import {initMixpanel} from "./mixpanel";
import {getConsents} from "../../shared/CookieManager/CookieManager";

export async function getAdaptors() {
    const adaptors = [];
    const preferences = await getConsents();
    adaptors.push(...initMixpanel(preferences));
    return adaptors;
}
